import { configNoHeaders } from '@api/constructor-api'
import store from '../store';

const fetchMembershipTierList = async () => {
    return await configNoHeaders(async (API) => {
        return await API.get(`membership-tier/restaurant/${store.getters['restaurant/restaurantUUID']}/rewards`);
    })
}

export default {
    fetchMembershipTierList
}
